import { render, staticRenderFns } from "./footerCopyright.vue?vue&type=template&id=35049eca&scoped=true"
import script from "./footerCopyright.vue?vue&type=script&lang=js"
export * from "./footerCopyright.vue?vue&type=script&lang=js"
import style0 from "./footerCopyright.vue?vue&type=style&index=0&id=35049eca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35049eca",
  null
  
)

export default component.exports